"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = require("react");

function getActiveOffset(offsets, scrollY) {
  var offsetsCopy = (0, _objectSpread2["default"])({}, offsets);

  if (!offsetsCopy[0]) {
    offsetsCopy[0] = "top";
  }

  var keys = (0, _keys["default"])(offsetsCopy);
  keys.sort();
  var result;

  for (var i = 0; i < keys.length; i++) {
    if (keys[i] <= scrollY) {
      result = offsetsCopy[keys[i]];
    }
  }

  return result;
}

function useScrollSegment() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isActive = (0, _react.useRef)(false); // ref instead of state prevents from extra re-renders.

  var _useState = (0, _react.useState)(0),
      counter = _useState[0],
      setCounter = _useState[1];

  var _config$from = config.from,
      from = _config$from === void 0 ? 0 : _config$from,
      to = config.to;
  (0, _react.useEffect)(function () {
    var updateScroll = function updateScroll() {
      if (window.scrollY >= from && !isActive.current) {
        isActive.current = true;
        setCounter(function (c) {
          return c + 1;
        });
      } else if (window.scrollY < from && isActive.current) {
        isActive.current = false;
        setCounter(function (c) {
          return c + 1;
        });
      }
    };

    window.addEventListener("scroll", updateScroll);
    updateScroll();
    return function cleanup() {
      window.removeEventListener("scroll", updateScroll);
    };
  }, [from, to]);
  return isActive.current;
}

var _default = useScrollSegment;
exports["default"] = _default;